export { default as ChatComponent } from "./ChatComponent";
